import type { CSSProperties } from 'react';

/** Единый набор линейных иконок (24×24, stroke 1.8). Заменяет эмодзи в интерфейсе. */
const PATHS: Record<string, string> = {
  table: 'M4 10h16M6 10l-1.5 9M18 10l1.5 9M8 10V7a4 4 0 0 1 8 0v3',
  shop: 'M6 8h12l1 12H5L6 8zM9 8V6a3 3 0 0 1 6 0v2',
  inventory: 'M5 8h14v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8zM9 8V6a3 3 0 0 1 6 0v2M5 12h14',
  profile: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 20a8 8 0 0 1 16 0',
  crystal: 'M12 3l6 6-6 12L6 9l6-6zM6 9h12M9 9l3 12M15 9l-3 12',
  shard: 'M12 4l5 8-5 8-5-8 5-8z',
  ticket: 'M4 8a2 2 0 0 0 2-2h12a2 2 0 0 0 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 0-2 2H6a2 2 0 0 0-2-2v-2a2 2 0 0 0 0-4V8zM10 6v12',
  sun: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  moon: 'M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z',
  sparkle: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3zM19 17l.7 1.8 1.8.7-1.8.7L19 22l-.7-1.8-1.8-.7 1.8-.7L19 17z',
  work: 'M4 8h16v11H4V8zM9 8V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M4 13h16',
  love: 'M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z',
  health: 'M3 12h4l2-5 3 10 3-8 2 3h4',
  advice: 'M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.3 1 2.1h5c0-.8.4-1.6 1-2.1A6 6 0 0 0 12 3z',
  flame: 'M12 3s5 4.5 5 9.5A5 5 0 0 1 7 12.5c0-2 1-3.5 2-4.5 0 1.5 1 2.5 2 2.5 0-3 1-5 1-7.5z',
  star: 'M12 3l2.6 5.6 6.1.7-4.5 4.2 1.2 6L12 16.5 6.6 19.5l1.2-6L3.3 9.3l6.1-.7L12 3z',
  gift: 'M4 10h16v10H4V10zM2 6h20v4H2V6zM12 6v14M12 6c-2-4-6-3-6-1s3 1 6 1zM12 6c2-4 6-3 6-1s-3 1-6 1z',
  history: 'M3 12a9 9 0 1 0 3-6.7M3 4v5h5M12 8v4l3 2',
  cards: 'M7 5h8a2 2 0 0 1 2 2v12H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zM17 8l2-.5a2 2 0 0 1 2.4 1.5l1.8 8.5',
  users: 'M9 12a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 20a6 6 0 0 1 12 0M17 11a3 3 0 1 0 0-6M21 20a5 5 0 0 0-4-4.9',
  motion: 'M4 6h16v12H4V6zM4 10h16M8 6v12M16 6v12',
  trash: 'M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6',
  chevron: 'M9 6l6 6-6 6',
  back: 'M15 6l-6 6 6 6',
  share: 'M12 3v12M8 7l4-4 4 4M5 13v6h14v-6',
  refresh: 'M4 12a8 8 0 0 1 13.7-5.7L20 8M20 4v4h-4M20 12a8 8 0 0 1-13.7 5.7L4 16M4 20v-4h4',
  plus: 'M12 5v14M5 12h14',
  check: 'M5 12l4 4L19 7',
  lock: 'M6 11h12v10H6V11zM8 11V7a4 4 0 0 1 8 0v4',
  thumbUp: 'M7 11v10H3V11h4zM7 11l4-8a2 2 0 0 1 2 2v4h5a2 2 0 0 1 2 2.3l-1.2 7A2 2 0 0 1 16.8 21H7',
  thumbDown: 'M7 13V3H3v10h4zM7 13l4 8a2 2 0 0 0 2-2v-4h5a2 2 0 0 0 2-2.3l-1.2-7A2 2 0 0 0 16.8 3H7',
  info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 11v6M12 7v1',
  eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
};

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 20, className = '', style, filled }: { name: IconName; size?: number; className?: string; style?: CSSProperties; filled?: boolean }) {
  return (
    <svg className={`ico ${className}`} width={size} height={size} viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden style={style}>
      <path d={PATHS[name]} />
    </svg>
  );
}
